import { render, staticRenderFns } from "./WishesSampleUpdate.vue?vue&type=template&id=5191531a&scoped=true"
import script from "./WishesSampleUpdate.vue?vue&type=script&lang=js"
export * from "./WishesSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./WishesSampleUpdate.vue?vue&type=style&index=0&id=5191531a&lang=css"
import style1 from "./WishesSampleUpdate.vue?vue&type=style&index=1&id=5191531a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191531a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5191531a')) {
      api.createRecord('5191531a', component.options)
    } else {
      api.reload('5191531a', component.options)
    }
    module.hot.accept("./WishesSampleUpdate.vue?vue&type=template&id=5191531a&scoped=true", function () {
      api.rerender('5191531a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/WishesSampleUpdate.vue"
export default component.exports